var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._g(_vm._b({staticStyle:{"color":"#F56C6C"}},'label',_vm.$attrs,false),_vm.$listeners),[_vm._v("* "),_c('span',{staticClass:"color666"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }